const STORAGE_KEYS = Object.freeze({
  user: "user",
  day: "day",
});

class AppStorageService {
  getStorage() {
    if (typeof window === "undefined") {
      return null;
    }
    return window.localStorage;
  }

  parseItem(key, rawValue, fallback = null) {
    if (!rawValue) {
      return fallback;
    }

    try {
      return JSON.parse(rawValue);
    } catch (error) {
      console.warn(`Invalid JSON stored for "${key}", ignoring persisted value.`, error);
      return fallback;
    }
  }

  getItem(key, fallback = null) {
    const storage = this.getStorage();
    if (!storage) {
      return fallback;
    }
    return this.parseItem(key, storage.getItem(key), fallback);
  }

  setItem(key, value) {
    const storage = this.getStorage();
    if (!storage) {
      return value;
    }

    if (value == null) {
      storage.removeItem(key);
      return null;
    }

    storage.setItem(key, JSON.stringify(value));
    return value;
  }

  removeItem(key) {
    const storage = this.getStorage();
    if (!storage) {
      return;
    }
    storage.removeItem(key);
  }

  getUser() {
    return this.getItem(STORAGE_KEYS.user, null);
  }

  setUser(user) {
    return this.setItem(STORAGE_KEYS.user, user);
  }

  clearUser() {
    this.removeItem(STORAGE_KEYS.user);
  }

  hasUser() {
    const user = this.getUser();
    return !!user?.accessToken;
  }

  getDay() {
    return this.getItem(STORAGE_KEYS.day, null);
  }

  setDay(dayState) {
    return this.setItem(STORAGE_KEYS.day, dayState);
  }

  clearDay() {
    this.removeItem(STORAGE_KEYS.day);
  }

  clearSession() {
    this.clearUser();
    this.clearDay();
  }
}

export { STORAGE_KEYS };
export default new AppStorageService();
